module.exports = __webpack_public_path__ + "static/media/logo-super.e71ab07e.svg";